var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"tips"},[_vm._v("互联网药品信息服务证编号：（浙）-经营性-2024-0423\n     "),_c('span',[_c('img',{attrs:{"src":"https://img.gegejia.com/img/2f4a9836c2efb08c1d5affae4180e06a.png","alt":""}}),_vm._v("浙ICP备2024064564号")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c7572fba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t97/block/footer.vue
// module id = null
// module chunks = 